import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import slideLeftTransition from '../../static/transitions/menuSlideLeft.scss'
import slideRightTransition from '../../static/transitions/menuSlideRight.scss'

const MegaMenuSlideTransition = ({
  children,
  enter = true,
  isSlidingLeft = true,
  show = false,
  unmountOnExit = true,
}) => (
  <CSSTransition
    classNames={isSlidingLeft ? slideLeftTransition : slideRightTransition}
    in={show}
    enter={enter}
    timeout={500}
    unmountOnExit={unmountOnExit}>
    {children}
  </CSSTransition>
)

MegaMenuSlideTransition.propTypes = {
  children: PropTypes.element,
  enter: PropTypes.bool,
  isSlidingLeft: PropTypes.bool,
  show: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
}

export default MegaMenuSlideTransition
